import React, { PropsWithChildren } from 'react';
import styles from 'assets/css/DetailLayout.module.scss';

const DetailLayout: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <section className={styles.detailView}>{children}</section>;
};

export default DetailLayout;
